<template>
	<Button v-if="showPaasUi" :type="paasButtonProps.type" @click="onPaasButtonClick" :class="paasButtonProps.className">
		{{ paasButtonProps.label }}
	</Button>
</template>

<script>
import { computed, onMounted, watch } from 'vue';
import { Button } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

import { useRouter } from 'vue-router';

import { useBaseStationsStore } from '@/stores/baseStations';
import { usePaasStore } from '@/stores/paas';
import { useLicenseStore } from '@/stores/licenseStore';


export default {
	components: {
		Button,
	},
	setup() {
		const { t } = useI18n();
		const baseStationsStore = useBaseStationsStore();
		const paasStore = usePaasStore();
		const paasButtonProps = computed(() => ({
			type: (paasStore.newTask ? 'primary' : 'default'),
			className: (paasStore.newTask ? 'new-paas-results' : '') + ' width-100',
			label: t('paas.' + (paasStore.newTask ? 'newResultsLabel' : 'header')),
		}));
		const licenseStore = useLicenseStore();
		const showPaasUi = computed(() => licenseStore.allowPaas && baseStationsStore.items.length > 0);
		if (licenseStore.allowPaas) {
			onMounted(() => {
				paasStore.updatePaasData();
				window.scrollTo(0, 0);
			});
		}
		watch(() => licenseStore.allowPaas, value => {
			if (value) {
				paasStore.updatePaasData();
			}
		});
		const router = useRouter();
		const onPaasButtonClick = () => router.push({ name: 'stats-type', params: { id: 'coordinates-correction' } });
		return {
			paasButtonProps,
			showPaasUi,
			onPaasButtonClick,
		};
	},
}
</script>
